import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import './css/aide.css';

const Aide = () => {
    const [selected, setSelected] = useState(0);
    const toogle = (i) => {
        if (selected === i) {
            setSelected(null);
        }
        setSelected(i);
    }
    let location = useLocation();


    const data = [
        {
            "id": 1,
            "name": "Item 1",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        },
        {
            "id": 2,
            "name": "Item 2",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        },
        {
            "id": 1,
            "name": "Item 3",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
    ];

    return (
        <div>
            <Helmet>
                <title>Aide </title>
                <meta name='description' content='Aide' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='aide_client'>
                <div className='container'>
                    <div className='bloc_aide'>
                        <div className='titre'>
                            <h1><i className='fa fa-question-circle-o'></i>Aide Foire Aux Questions</h1>
                        </div>
                        <div className='liste_aide'>
                            {data.map((el, index) => {
                                return (<div className='item_aide' key={index}>
                                    <div className="form-check">
                                        <div>
                                            <input className="form-check-input" type="checkbox" defaultValue id={el.name} />
                                            <label className="form-check-label" htmlFor={el.name} aria-controls="example-fade-text" onClick={() => toogle(index)}>
                                                {el.name}
                                            </label>
                                        </div>
                                        <span>{selected === index ? <i className='fa fa-chevron-up'></i> : <i className='fa fa-chevron-down'></i>}</span>
                                    </div>
                                    <div className={selected === index ? 'content show' : 'content'}>
                                        <div className='content_item'>
                                            <span>{el.description}</span>
                                        </div>
                                    </div>

                                </div>);
                            })}

                        </div>
                        <div className='d-flex justify-content-center'>
                            <button className="btn btn_send_aide">Envoyer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Aide